import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Shop from "@/components/Shop";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopPage() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  if (products === null) return <div className="py-32 text-center text-zinc-500">Loading...</div>;

  if (products.length === 0) {
    return (
      <div className="py-32 text-center" data-testid="shop-empty">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <p className="text-zinc-500 text-sm">No products available right now.</p>
          <Link to="/" className="inline-flex items-center gap-2 text-gg-red hover:text-white text-sm font-heading uppercase tracking-widest mt-4 transition-colors">
            <ArrowLeft size={14} /> Back to Home
          </Link>
        </motion.div>
      </div>
    );
  }

  return (
    <div data-testid="shop-page">
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-heading text-gg-red text-xs uppercase tracking-[0.3em]">Shop</motion.span>
          <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-heading text-2xl sm:text-3xl font-extrabold uppercase tracking-tight mt-1">GG <span className="text-gg-red">Store</span></motion.h1>
        </div>
      </div>
      <Shop />
    </div>
  );
}
